module.exports = "/img/campaigns/intent-transaction-tooltip.png?40f0cdeb47667c26ba2a453f003081db";